export const MAP_CONFIG = {
  printWidget: {
    forceFeatureAttributes: true,
    format: 'pdf',
    showLabels: true,
    layoutOptions: {
      titleText: 'Mapbuilder',
      copyrightText: '© World Resources Institute',
      authorText: 'GFW Mapbuilder',
      scalebarUnit: 'Kilometers',
      customTextElements: [{ title: 'GFW Mapbuilder' }, { subtitle: 'Make maps that matter' }],
      legendLayers: [],
    },
  },
};
